import CyDialog from '@/components/ui/cy-dialog.vue';
import CyBreadcrumb from '@/components/ui/cy-breadcrumb.vue';
import CyButton from '@/components/ui/cy-button.vue';
import CyPopover from '@/components/ui/popover/popover.vue';
import CyInput from '@/components/ui/input/input.vue';
import CySelect from '@/components/ui/select/select.vue';
import CyHeading from '@/components/ui/cy-heading.vue';
import CyPagination from '@/components/ui/pagination/pagination.vue';
import CyForm from '@/components/ui/cy-form.vue';
import CyFormItem from '@/components/ui/cy-form-item.vue';
import CyCheckbox from '@/components/ui/cy-checkbox.vue';
import CyCheckboxGroup from '@/components/ui/cy-checkbox-group.vue';
import CyRadio from '@/components/ui/cy-radio.vue';
import CyRadioGroup from '@/components/ui/cy-radio-group.vue';
import LoginModal from '@/components/base/login/login-modal.vue';
import CyOption from '@/components/ui/select/option.vue';
import FooterLayout from '@/components/base/footer/footer-layout.vue';
import HeaderLayout from '@/components/base/header/header-layout.vue';
import ContentLayout from '@/components/base/content/content-layout.vue';
import CySkeletonShape from '@/components/ui/cy-skeleton-shape.vue'
import CySkeletonLine from '@/components/ui/cy-skeleton-line.vue'

export default {
  install: (app: any) => {
    app.component('CyDialog', CyDialog);
    app.component('CyBreadcrumb', CyBreadcrumb);
    app.component('CyPopover', CyPopover);
    app.component('CyButton', CyButton);
    app.component('CyHeading', CyHeading);
    app.component('CyInput', CyInput);
    app.component('CySelect', CySelect);
    app.component('CyPagination', CyPagination);
    app.component('CyForm', CyForm);
    app.component('CyFormItem', CyFormItem);
    app.component('CyCheckbox', CyCheckbox);
    app.component('CyCheckboxGroup', CyCheckboxGroup);
    app.component('CyRadio', CyRadio);
    app.component('CyRadioGroup', CyRadioGroup);
    app.component('LoginModal', LoginModal);
    app.component('CyOption', CyOption);
    app.component('HeaderLayout', HeaderLayout);
    app.component('ContentLayout', ContentLayout);
    app.component('FooterLayout', FooterLayout);
    app.component('CySkeletonShape', CySkeletonShape);
    app.component('CySkeletonLine', CySkeletonLine);
  }
}
